module.exports = __webpack_public_path__ + "img/canjiz.158f562b.png";